import React from 'react';
import styled from 'styled-components';
import { ButtonPrimary } from '@spotify-internal/encore-web';

import serverRenderingUtils from 'helpers/serverRenderingUtils';
import { useT } from 'client/i18n/hooks/useT';
import { COLOR_BLACK } from 'client/components/MarketingPagesShared/styles';
import { IntegrationRedirectScreenSection } from './styles';
import { VALID_VIDEO_PARTNERS } from '../constants';

const IntegrationRedirectScreenErrorContent = styled.div`
  max-width: 448px;
  margin: 0 auto;
  color: ${COLOR_BLACK};
  text-align: center;

  h2 {
    margin: 0 0 8px;
    font-size: 2rem;
    line-height: 40px;
    letter-spacing: -0.04em;
  }

  p {
    margin: 0 0 20px;
    font-size: 1rem;
    line-height: 24px;
  }
`;

export function IntegrationRedirectScreenError({
  integrationName,
}: {
  integrationName: string;
}) {
  const t = useT();
  const { displayName, redirectUrl } =
    VALID_VIDEO_PARTNERS[integrationName] || {};

  const handleOnClick = () => {
    if (!serverRenderingUtils.windowUndefined()) {
      window.open(redirectUrl, '_blank');
    }
  };

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Finalize and translate text when we have final copy
  return (
    <IntegrationRedirectScreenSection>
      <IntegrationRedirectScreenErrorContent>
        <h2>
          {t(
            'IntegrationRedirectScreenError.Title',
            'Something went wrong',
            'The title for the Integration Redirect Screen when an error occurs due to an invalid partner or a partner not providing all of the necessary materials'
          )}
        </h2>
        <p>
          {t(
            'IntegrationRedirectScreenError.Body',
            'If the partner is invalid or gives us the wrong information, we should say so and can add a button to return where they came from.',
            'The body for the Integration Redirect Screen when an error occurs due to an invalid partner or a partner not providing all of the necessary materials'
          )}
        </p>
        {displayName && redirectUrl && (
          <ButtonPrimary onClick={handleOnClick}>
            {t(
              'IntegrationRedirectScreenError.Action',
              'Go back to {displayName}',
              'The action for the Integration Redirect Screen when an error occurs due to an invalid partner or a partner not providing all of the necessary materials to return to the integration partner. Full example with variable is: Go back to Riverside.fm',
              { displayName }
            )}
          </ButtonPrimary>
        )}
      </IntegrationRedirectScreenErrorContent>
    </IntegrationRedirectScreenSection>
  );
}
